import { ButtonProps } from '@customTypes'

import { EdgeRadius } from '../helpers/types'

const edgeRadius: EdgeRadius = {
  rounded: '0.25em',
  sharp: '0',
  default: '3em',
}

export const getEdgeRadius = ({
  edgeType = 'default',
  buttonType,
}: Pick<ButtonProps, 'edgeType' | 'buttonType'>) =>
  buttonType === 'link' ? edgeRadius.sharp : edgeRadius[edgeType]
